import React from 'react';
export const CommentContext = /*#__PURE__*/ React.createContext({
    comment: {},
    isEditing: false,
    isReplying: false,
    isPeeking: false,
    isReduxReady: false,
    canShowActionMenu: false,
    isCommentVisible: true,
    setEditingState: ()=>null,
    setCanShowActionMenu: ()=>null,
    setPeeking: ()=>null
});
CommentContext.displayName = 'CommentContext';

//# sourceMappingURL=CommentContext.js.map